import _classCallCheck from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/createClass.js";
import defaultHtmlSerializer from "./schema";

var escapeHTML = function escapeHTML(string) {
  var htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  };
  var reUnescapedHtml = /[&<>"']/g;
  var reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
  return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, function (chr) {
    return htmlEscapes[chr];
  }) : string;
};

var RichTextResolver = /*#__PURE__*/function () {
  function RichTextResolver(schema) {
    _classCallCheck(this, RichTextResolver);

    if (!schema) {
      schema = defaultHtmlSerializer;
    }

    this.marks = schema.marks || [];
    this.nodes = schema.nodes || [];
  }

  _createClass(RichTextResolver, [{
    key: "addNode",
    value: function addNode(key, schema) {
      this.nodes[key] = schema;
    }
  }, {
    key: "addMark",
    value: function addMark(key, schema) {
      this.marks[key] = schema;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (data.content && Array.isArray(data.content)) {
        var html = "";
        data.content.forEach(function (node) {
          html += _this.renderNode(node);
        });
        return html;
      }

      console.warn("The render method must receive an object with a content field, which is an array");
      return "";
    }
  }, {
    key: "renderNode",
    value: function renderNode(item) {
      var _this2 = this;

      var html = [];

      if (item.marks) {
        item.marks.forEach(function (m) {
          var mark = _this2.getMatchingMark(m);

          if (mark) {
            html.push(_this2.renderOpeningTag(mark.tag));
          }
        });
      }

      var node = this.getMatchingNode(item);

      if (node && node.tag) {
        html.push(this.renderOpeningTag(node.tag));
      }

      if (item.content) {
        item.content.forEach(function (content) {
          html.push(_this2.renderNode(content));
        });
      } else if (item.text) {
        html.push(escapeHTML(item.text));
      } else if (node && node.singleTag) {
        html.push(this.renderTag(node.singleTag, " /"));
      } else if (node && node.html) {
        html.push(node.html);
      }

      if (node && node.tag) {
        html.push(this.renderClosingTag(node.tag));
      }

      if (item.marks) {
        item.marks.slice(0).reverse().forEach(function (m) {
          var mark = _this2.getMatchingMark(m);

          if (mark) {
            html.push(_this2.renderClosingTag(mark.tag));
          }
        });
      }

      return html.join("");
    }
  }, {
    key: "renderTag",
    value: function renderTag(tags, ending) {
      if (tags.constructor === String) {
        return "<".concat(tags).concat(ending, ">");
      }

      var all = tags.map(function (tag) {
        if (tag.constructor === String) {
          return "<".concat(tag).concat(ending, ">");
        } else {
          var h = "<".concat(tag.tag);

          if (tag.attrs) {
            for (var key in tag.attrs) {
              var value = tag.attrs[key];

              if (value !== null) {
                h += " ".concat(key, "=\"").concat(value, "\"");
              }
            }
          }

          return "".concat(h).concat(ending, ">");
        }
      });
      return all.join("");
    }
  }, {
    key: "renderOpeningTag",
    value: function renderOpeningTag(tags) {
      return this.renderTag(tags, "");
    }
  }, {
    key: "renderClosingTag",
    value: function renderClosingTag(tags) {
      if (tags.constructor === String) {
        return "</".concat(tags, ">");
      }

      var all = tags.slice(0).reverse().map(function (tag) {
        if (tag.constructor === String) {
          return "</".concat(tag, ">");
        } else {
          return "</".concat(tag.tag, ">");
        }
      });
      return all.join("");
    }
  }, {
    key: "getMatchingNode",
    value: function getMatchingNode(item) {
      if (typeof this.nodes[item.type] !== "function") {
        return;
      }

      return this.nodes[item.type](item);
    }
  }, {
    key: "getMatchingMark",
    value: function getMatchingMark(item) {
      if (typeof this.marks[item.type] !== "function") {
        return;
      }

      return this.marks[item.type](item);
    }
  }]);

  return RichTextResolver;
}();

export default RichTextResolver;